/**
 * Dropdown Button
 * 
 * @Author: Focci
 * @Date: 2023-06-17 10:11:47
 * @Last Modified by: Focci
 * @Last Modified time: 2023-06-17 10:11:47
 */

import PropTypes from 'prop-types'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import clsx from 'clsx'

export default function FilterDropdownTrigger({
  actived = false,
  label = '',
  className = '',
  prevIcon,
  showIcon = true,
  count,
  unActivedClassName = '',
  activedClassName = 'border-secondary text-secondary',
}) {
  return (
    <div
      className={clsx([
        'h-8 border border-cdc max-w-40 shadow-sm rounded-sm',
        'px-4 flex items-center gap-1 cursor-pointer select-none',
        className,
        !actived && unActivedClassName,
        actived && activedClassName,
      ])}
    >
      {prevIcon}
      <div className="truncate font-medium">
        {label}
      </div>
      {!!count && (
        <div className="bg-primary rounded-full px-1 text-f.6 text-white leadding-none flex items-center">
          {count}
        </div>
      )}
      {showIcon && (
        <span className={clsx(['-mr-2 flex transition-transform', actived && 'rotate-180'])}>
          <KeyboardArrowDownIcon sx={{ fontSize: '.8rem' }} />
        </span>
      )}
    </div>
  )
}

FilterDropdownTrigger.propTypes = {
  actived: PropTypes.bool,
  label: PropTypes.node,
  className: PropTypes.string,
  prevIcon: PropTypes.node,
  showIcon: PropTypes.bool,
  activedClassName: PropTypes.string,
}
